import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination } from 'swiper/modules'
import { colors } from '@/components/atoms/colors'
import { urlForImage } from '@/sanity/lib/image'
import Image from 'next/image'
import { useMediaQuery } from '@mui/material'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/pagination'

const Galleries = ({ galleries }) => {
  const base = 'relative w-full aspect-[3/4] md:aspect-video md:h-[70vh]'
  const isMobile = useMediaQuery('(max-width: 767px)')

  return (
    <div className={base}>
      <Swiper
        slidesPerView={1}
        pagination
        modules={[Pagination]}
        className="w-full h-full"
        style={{
          '--swiper-pagination-color': colors.khaki, // warna bullet aktif
          '--swiper-pagination-bullet-inactive-color': colors.dune, // warna bullet tidak aktif
          '--swiper-pagination-bullet-inactive-opacity': '1',
          '--swiper-pagination-bullet-size': isMobile ? '7px' : '10px',
          '--swiper-pagination-bullet-horizontal-gap': '10px',
          '--swiper-pagination-bottom': isMobile ? '20px' : '30px',
        }}
      >
        {galleries.map((gallery, id) => (
          <SwiperSlide key={id}>
            <div className="relative w-full h-full">
              <Image
                src={urlForImage(gallery.image).url()}
                alt={gallery.image.alt}
                fill
                placeholder="blur"
                blurDataURL={gallery.image.metadata.lqip}
                className="object-cover"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default Galleries
